import styled from 'styled-components';
export { CATALOG_HEADER_TOP_SPACING } from 'utils/hooks/useOffsetTop';
import { CATALOG_HEADER_TOP_SPACING } from 'utils/hooks/useOffsetTop';

export const CatalogStickyHeaderOuter = styled.div<{ $suppressTopSpacing?: boolean }>`
  width: 100%;
  background: ${({ theme }) => theme.color.white};
  padding-top: ${({ $suppressTopSpacing }) => ($suppressTopSpacing ? 0 : CATALOG_HEADER_TOP_SPACING)}px;
  box-sizing: border-box;
`;

export const CatalogStickyHeaderStack = styled.div`
  width: 100%;
  border-radius: 12px;
  overflow: visible;
  border: 1px solid ${({ theme }) => theme.color.grey85};
  background: ${({ theme }) => theme.color.white};
  box-sizing: border-box;
`;

export const CatalogConnectedTabBar = styled.div`
  width: 100%;
  background: ${({ theme }) => theme.color.brand_black};
  padding: 4px 12px 6px;
  box-sizing: border-box;

  & > div {
    width: 100%;
    min-width: 0;
    padding: 0;
    background: transparent;
  }
`;
